var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'vue-class-component';
import * as _ from 'lodash';
import gql from 'graphql-tag';
import FilterList from './FilterList.vue';
import { whereQuery } from '@/services/sharedForm';
import getUser from '@/services/user';
import { EXTERNALS } from '@/queries/inventory';
var ExternalInventory = /** @class */ (function (_super) {
    __extends(ExternalInventory, _super);
    function ExternalInventory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.externals = [];
        _this.allExternals = [];
        _this.externalData = [];
        _this.selectedSilo = null;
        _this.loading = false;
        _this.bolUnsubscribe = null;
        _this.bols = [];
        _this.errMsg = false;
        _this.sortDir = 'desc';
        _this.sortField = 'date';
        _this.user = {};
        _this.firstRun = true;
        _this.options = {
            showLocation: true,
            showProduct: true,
            multiple: true,
            altLocations: [],
            selectedLocation: [],
            selectedProduct: [],
            changeOptions: function () { return _this.getData(); }
        };
        return _this;
    }
    ExternalInventory.prototype.metaInfo = function () {
        return {
            title: 'Inventory'
        };
    };
    ExternalInventory.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, getUser()];
                    case 1:
                        _a.user = _b.sent();
                        this.options.company = {
                            name: this.user.company
                        };
                        this.getData();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExternalInventory.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, locations, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.loading) {
                            return [2 /*return*/];
                        }
                        this.loading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$apollo.query({
                                query: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["query ", ""], ["query ", ""])), EXTERNALS),
                                variables: {
                                    where: whereQuery(this.options),
                                },
                                fetchPolicy: 'no-cache'
                            })];
                    case 2:
                        res = _a.sent();
                        if (!res.data) {
                            throw new Error('No data');
                        }
                        if (this.firstRun) {
                            locations = _.map(res.data.externals, function (external) {
                                return { name: external.location };
                            });
                            this.options = Object.assign({}, this.options, { altLocations: _.sortBy(_.uniqBy(locations, 'name'), 'name') });
                            this.firstRun = false;
                        }
                        this.externals = _.map(res.data.externals, function (external) {
                            external.tons = external.current_weight / 2000;
                            return external;
                        });
                        if (this.externals.length) {
                            this.calcExternalData();
                        }
                        else {
                            this.externalData = null;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.$toast.open({
                            duration: 5000,
                            message: 'Error getting data. Please try again.',
                            position: 'is-top',
                            type: 'is-danger'
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ExternalInventory.prototype.calcExternalData = function () {
        var externalData = [];
        var productGroup = _.groupBy(this.externals, 'product');
        var locationGroup = _.groupBy(this.externals, 'location');
        _.map(productGroup, function (val, key) {
            var findProductIndex = _.findIndex(externalData, { name: key });
            if (findProductIndex === -1) {
                findProductIndex = externalData.length;
                externalData.push({
                    name: key,
                    lbs: 0,
                    tons: 0
                });
            }
            _.forEach(val, function (external) { return externalData[findProductIndex].lbs += external.current_weight; });
            externalData[findProductIndex].tons = externalData[findProductIndex].lbs / 2000;
        });
        _.map(locationGroup, function (val, key) {
            var findProductIndex = _.findIndex(externalData, { name: key });
            if (findProductIndex === -1) {
                findProductIndex = externalData.length;
                externalData.push({
                    name: key,
                    lbs: 0,
                    tons: 0
                });
            }
            _.forEach(val, function (external) { return externalData[findProductIndex].lbs += external.current_weight; });
            externalData[findProductIndex].tons = externalData[findProductIndex].lbs / 2000;
        });
        this.externalData = externalData;
    };
    ExternalInventory = __decorate([
        Component({
            name: 'external-inventory',
            components: {
                'filter-list': FilterList
            }
        })
    ], ExternalInventory);
    return ExternalInventory;
}(Vue));
export default ExternalInventory;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalInventory.vue
// module id = 784
// module chunks = 1